import { useLocale } from 'next-intl';
import { useEffect, useState } from 'react';

interface UseLottieDataProps {
  readonly path: string;
}

interface UseLottieDataState {
  readonly animationData: object | null;
  readonly isError: boolean;
  readonly isLoading: boolean;
}

const useLottieData = ({ path }: UseLottieDataProps): UseLottieDataState => {
  const selectedLocale = useLocale();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isError, setIsError] = useState<boolean>(false);
  const [animationData, setAnimationData] = useState<object | null>(null);

  useEffect(() => {
    setIsLoading(true);

    import(`./lotties/${path}-${selectedLocale}.json`)
      .then((data) => {
        setIsLoading(false);
        setIsError(false);
        setAnimationData(data as object);
      })
      .catch(() => {
        setIsLoading(false);
        setIsError(true);
      });
  }, [path, selectedLocale]);

  return {
    animationData,
    isError,
    isLoading,
  };
};

export default useLottieData;
